import fetch from '@/utils/fetch'

export function getKnowledgeList (keywords) {
  console.log('-------api-getKnowledgeList---')
  return fetch({
    url: '/getKnowledgeList',
    params: {
      keywords
    },
    method: 'get'
  })
}

export function getKLByProblemGuid (pguid) {
  console.log('-------api-getKLByProblemGuid---pguid==' + pguid)
  return fetch({
    url: '/getKLByProblemGuid',
    params: {
      pguid
    },
    method: 'get'
  })
}

export function addNewKnowledge (data) {
  return fetch({
    url: '/addNewKnowledge',
    data,
    method: 'post'
  })
}

export function getKnowledgeByGuid (kguid) {
  console.log('-------api-getKnowledgeByGuid---')
  return fetch({
    url: '/getKnowledgeByGuidManager',
    params: {
      kguid
    },
    method: 'get'
  })
}

export function updateKnowledgeByGuid (data) {
  return fetch({
    url: '/updateKnowledgeByGuid',
    data,
    method: 'post'
  })
}

export function weixintest (data) {
  return fetch({
    url: 'https://apitest.mch.weixin.qq.com/sandboxnew/pay/getsignkey',
    data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_knowledge.js